<template>
  <div class="py-4">
    <v-dialog
      :close-on-content-click="false"
      v-model="showSectionCreator"
      :fullscreen="$vuetify.breakpoint.xs"
      max-width="1864px"
    >
      <SectionCreator
        :existing-section-infos="{ journalId: journal.id, title: journal.title }"
        @close-section-creator="showSectionCreator = false;"
      />
    </v-dialog>
    <v-dialog
      :close-on-content-click="false"
      v-model="showJournalHistory"
      :fullscreen="$vuetify.breakpoint.xs"
      max-width="1864px"
    >
      <JournalHistory
        :journal-id="journal.id"
        @close="showJournalHistory = false;"
      />
    </v-dialog>
    <span>
      <h4 class="journal-title pl-3 py-3">
        {{ journal.title }} ({{ journal.recommendations.length }})
      </h4>
      <span>
        <v-tooltip
          v-if="journal.entityType === 'group'"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="ml-2"
              v-bind="attrs"
              v-on="on"
            >
              group
            </v-icon>
          </template>
          <span>
            {{ $t('views.journal.sections.header.members.tooltip.forGroup') }}
          </span>
        </v-tooltip>
        <v-tooltip
          v-if="journal.entityType === 'reflection'"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="ml-2"
              v-bind="attrs"
              v-on="on"
            >
              group
            </v-icon>
          </template>
          <span>
            {{ $t('views.journal.sections.header.members.tooltip.forReflection') }}
          </span>
        </v-tooltip>
        <v-tooltip
          v-if="journal.entityType === 'user'"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="ml-2"
              v-bind="attrs"
              v-on="on"
            >
              lock
            </v-icon>
          </template>
          <span>
            {{ $t('views.journal.sections.header.members.tooltip.forUser') }}
          </span>
        </v-tooltip>
        <v-tooltip
          v-if="journal.editable"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              @click.exact.stop.prevent="configure()"
              class="ml-2"
              v-bind="attrs"
              v-on="on"
            >
              settings
            </v-icon>
          </template>
          <span>
            {{ $t('views.journal.sections.header.settings.tooltip') }}
          </span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="journal.editable && (journal.entityType === 'user' || journal.entityType === 'reflection')"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              @click.exact.stop.prevent="archive(journal)"
              class="ml-2"
              v-bind="attrs"
              v-on="on"
            >
              archive
            </v-icon>
          </template>
          <span>
            {{ $t('views.journal.sections.header.archive.tooltip') }}
          </span>
        </v-tooltip>
        <v-tooltip
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              @click.exact.stop.prevent="openHistory()"
              class="ml-2"
              v-bind="attrs"
              v-on="on"
            >
              history
            </v-icon>
          </template>
          <span>
            {{ $t('views.journal.sections.header.history.tooltip') }}
          </span>
        </v-tooltip>
      </span>
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { types } from '../../store/rootTypes';
import SectionCreator from './journal/SectionCreator';
import JournalHistory from './journal/JournalHistory';

export default {
  name: 'JournalSectionHeader',
  components: {
    SectionCreator,
    JournalHistory,
  },
  props: {
    journal: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showSectionCreator: false,
    showJournalHistory: false,
  }),
  computed: {
    journalHistoryRef() {
      return `journalHistory${this.journal.id}`;
    },
  },
  methods: {
    ...mapActions({
      archivePipelinedJournal: types.recommendationBasedJournals.actions.archivePipelinedJournal,
    }),
    archive(journal) {
      this.archivePipelinedJournal({ pipelinedJournalId: journal.id });
    },
    configure() {
      this.showSectionCreator = !this.showSectionCreator;
    },
    openHistory() {
      this.showJournalHistory = !this.showJournalHistory;
    },
  },
};
</script>
<style scoped>
.journal-title {
  display: inline;
}
</style>
